"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessages = void 0;
const error_messages_json_1 = __importDefault(require("./error_messages.json"));
exports.ErrorMessages = error_messages_json_1.default;
